import Header from '../../lib/AppBar';
import './dashboard.scss';
import './commercial.scss';
import en from '../../lang/en-us';
import RouteWrapper from './routes';
import { DashboardRoutes } from './routeConfig';
import { useState } from 'react';
import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import { CombinedState } from 'redux';
import { RootStateType } from '../../redux-store/reducers';
import { useEffect } from 'react';
import { onLogout, updateFirstTimeSettings } from '../../redux-store/actions/login';
import { FundInfoDialog } from './home';
import { AuthState } from '../../redux-store/types/login';
import { useDeviceAuthentication } from '../../lib/Authentication';
import LoginPin from '../auth/LoginPin';
import LoginSetPin from '../auth/LoginSetPin';
import { isMobileDevice } from '../../utils/constants';
import {
    getMasterFunds,
    getPurchaseDetails,
    getMasterData,
} from '../../redux-store/actions/newPurchase';
import { getAmcList } from '../../redux-store/actions/nct';
import { IsAllow } from '../../redux-store/types/portfolio';
import KYCRegisterPopup from '../common/KYCRegisterPopup';
import { NomineePopup } from './NomineePopup';

const { dashboard } = en;

const LINK = 'link';
const PORTFOLIOS = '/portfolio';
const HOME = '/home';
const NCT = '/nct';
const INVEST = '/commercial';
const TRACK = '/track';
const UNCLAIMED = '/unclaimed-payout';
const SEBICAS = '/sebi-cas';

const selectTypeByPath = (pathname: string) => {
    if (pathname.includes(HOME)) {
        return 1;
    } else if (pathname.includes(PORTFOLIOS)) {
        return 2;
    } else if (pathname.includes(INVEST)) {
        return 3;
    } else if (pathname.includes(NCT)) {
        return 4;
    } else if (pathname.includes(TRACK)) {
        return 5;
    } else if (pathname.includes(SEBICAS)) {
        return 6;
    } else {
        return null;
    }
};

interface ActionTabProps {
    stateKey: string;
    route?: string;
}

const HOME_ACTION: ActionTabProps = {
    stateKey: `${LINK}1`,
    route: HOME,
};
const PORTFOLIOS_ACTION: ActionTabProps = {
    stateKey: `${LINK}2`,
    route: PORTFOLIOS,
};
const INVEST_ACTION: ActionTabProps = {
    stateKey: `${LINK}3`,
    route: INVEST,
};
const NCT_ACTION: ActionTabProps = {
    stateKey: `${LINK}4`,
    route: NCT,
};
const TRACK_ACTION: ActionTabProps = {
    stateKey: `${LINK}5`,
    route: TRACK,
};
const UNCLAIMED_LAYOUT: ActionTabProps = {
    stateKey: `${LINK}5`,
    route: UNCLAIMED,
};
const SEBICAS_ACTION: ActionTabProps = {
    stateKey: `${LINK}6`,
    route: SEBICAS,
};

function Dashboard(props: any) {
    const { path } = props.match;
    const [show, setShow] = useState<boolean>(false);
    const [activeClass, setClass] = useState<boolean>(false);
    const [fundsInfoShow, setFundsInfoShow] = useState<boolean>(props.firstTimeLoggedIn);
    const { pathname = '' } = props.location;
    const [actionTab, setTab] = useState<string>(`${LINK}${selectTypeByPath(pathname)}`);
    const pageLink = pathname.replace('/portal/', '');
    const { askAuthentication } = useDeviceAuthentication({
        onAuthenticationTimeOut: () => {
            props.updateFirstTimeSettings({ isAutheticatedByDeviceOrPin: false });
            askAuthentication();
        },
    });

    const { ftTransactionFlag } = useSelector(({ authReducer }: RootStateType) => ({
        ftTransactionFlag: authReducer?.ftTransactions,
    }));

    const pathName = [
        '/portfolio-scheme-details',
        '/portal/profile',
        '/portal/update-security-questions',
        '/portal/unclaimed-payout',
        '/portal/sebi-cas',
        '/portal/track',
        '/portal/track-for-nct',
        '/portal/track-for-transaction',
        '/portal/unregistered-folios',
        '/portal/unregistered-folios-success',
        '/portal/faq',
    ];

    const handleActionChange =
        ({ stateKey, route }: ActionTabProps) =>
        () => {
            setTab(stateKey);
            props.history.push(`${path}${route}`);
            if (show) {
                setShow(false);
            }
            if (activeClass) {
                setClass(false);
            }
        };

    useEffect(() => {
        const { location } = props;
        const { pathname } = location;
        setTab(`${LINK}${selectTypeByPath(pathname)}`);
    }, [props.location.pathname]);

    const _isMobile = isMobileDevice();

    useEffect(() => {
        async function fetchPortfolio() {
            try {
                await props.getAmcList();
                if (ftTransactionFlag === IsAllow.YES) {
                    props.getMasterFunds();
                    await props.getMasterData();
                }
            } catch (err: any) {
                alert(err.message);
            }
        }
        if ((_isMobile && props.isAutheticatedByDeviceOrPin) || !_isMobile) {
            fetchPortfolio();
        }
    }, [props.isAutheticatedByDeviceOrPin]);

    const findPath = (pathname: string) => {
        // if(pathname.includes('/nct/actions')){
        //     return false;
        // }
        return pathname.includes('/nct') ||
            pathname.includes('/commercial') ||
            !!pathName.find((_ele: string) => pathname.includes(_ele))
            ? true
            : false;
    };
    const _setFundInfoShow = (value: boolean) => {
        const settings: Partial<AuthState> = { firstTimeLoggedIn: false };
        props.updateFirstTimeSettings(settings);
        setFundsInfoShow(value);
    };

    // Mobile Flow

    // Set Pin and initial settings
    if (_isMobile) {
        if (!props.initialSettingsAsked) {
            if (!props.enabledPin || (!props.enableTwoFactorAuth && !props.skipDeviceAuth)) {
                return <LoginSetPin {...props} />;
            }
        }
    }
    //Ask authentication
    if (_isMobile && !props.isAutheticatedByDeviceOrPin) {
        return <LoginPin {...props} />;
    }

    return (
        <div className="container-fluid db-layout">
            <Header
                user={props.displayName ?? ''}
                authorized={true}
                {...props}
                showHamburgerMenu={() => setClass(true)}
            />
            <div
                className={`db-content ${pageLink} ${
                    findPath(pathname) ? `mobile-db-content` : ``
                }`}
            >
                <div className={`db-content-left ${activeClass && `active`}`}>
                    <ul className={actionTab}>
                        <a
                            className="mobile_mode mobile-toggle-close"
                            onClick={() => setClass(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </a>
                        <li>
                            <a
                                onClick={handleActionChange(HOME_ACTION)}
                                className={actionTab === 'link1' ? 'active' : ''}
                            >
                                <img src="/images/home-active.svg" alt="icon" />
                                <span>{dashboard.dashboardLeft.link1}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                onClick={handleActionChange(PORTFOLIOS_ACTION)}
                                className={actionTab === 'link2' ? 'active' : ''}
                            >
                                <img src="/images/portfolio-active.svg" alt="icon" />
                                <span>{dashboard.dashboardLeft.link2}</span>
                            </a>
                        </li>
                        {!!ftTransactionFlag && ftTransactionFlag === IsAllow.YES && (
                            <li style={{ position: 'relative' }}>
                                <img
                                    className="new-icon"
                                    src="/images/new_menu_icon.svg"
                                    alt="icon"
                                    style={{
                                        position: 'absolute',
                                        height: 'auto',
                                        top: 10,
                                        left: 75,
                                    }}
                                />
                                <a
                                    onClick={handleActionChange(INVEST_ACTION)}
                                    className={actionTab === 'link3' ? 'active' : ''}
                                >
                                    <img src="/images/invest.svg" alt="icon" />
                                    <span>{dashboard.dashboardLeft.invest}</span>
                                </a>
                            </li>
                        )}
                        <li>
                            <a
                                onClick={() => {
                                    setClass(false);
                                    setShow(true);
                                }}
                                className={actionTab === 'link4' ? 'active' : ''}
                            >
                                <img src="/images/nct-active.svg" alt="icon" />
                                <span>{dashboard.dashboardLeft.link3}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                onClick={handleActionChange(TRACK_ACTION)}
                                className={actionTab === 'link5' ? 'active' : ''}
                            >
                                <img src="/images/status-active.svg" alt="icon" />
                                <span>{dashboard.dashboardLeft.link4}</span>
                            </a>
                        </li>
                        {/* <li>
                            <a
                                onClick={handleActionChange(UNCLAIMED_LAYOUT)}
                                className={actionTab === 'link5' ? 'active' : ''}
                            >
                                <img src="/images/unclaimed.svg" alt="icon" />
                                <span>{dashboard.dashboardLeft.link5}</span>
                            </a>
                        </li> */}
                        <li>
                            <a
                                onClick={handleActionChange(SEBICAS_ACTION)}
                                className={actionTab === 'link6' ? 'active' : ''}
                            >
                                <img src="/images/sebi-cas.svg" alt="icon" />
                                <span>{dashboard.dashboardLeft.link6}</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div
                    className={`db-content-right ${findPath(pathname) ? `full-width` : ``}`}
                    id="db-content-right"
                >
                    <div className="maxWidth">
                        <KYCRegisterPopup />
                        <RouteWrapper
                            matchPath={path}
                            initPath={`/home`}
                            routes={DashboardRoutes}
                        />
                    </div>
                </div>
            </div>
            <Dialog maxWidth={'sm'} open={show} aria-labelledby="note-modals">
                <div className="note-modals">
                    <h3>{dashboard.noteModals.nctModal.heading}</h3>
                    <p>{dashboard.noteModals.nctModal.info}</p>
                    <div className="note-modals-btns">
                        <Button className="customBtn" onClick={handleActionChange(NCT_ACTION)}>
                            {dashboard.noteModals.nctModal.proceedText}
                        </Button>
                        <Button className="customBtn cancelBtn" onClick={() => setShow(!show)}>
                            {dashboard.noteModals.nctModal.cancelText}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <FundInfoDialog setFundInfoShow={_setFundInfoShow} fundInfoShow={fundsInfoShow} />
        </div>
    );
}
export default connect(
    ({ authReducer, authentication }: CombinedState<RootStateType>) => ({
        ...authReducer,
        ...authentication,
    }),
    {
        getAmcList,
        updateFirstTimeSettings,
        onLogout,
        getMasterFunds,
        getMasterData,
    },
)(Dashboard);
